export const AppConstants = {
  // In production this comes from REACT_APP_SERVICEURL_V2. For local/LAN testing where it isn't
  // set, derive the admin API from the host the page was opened on (the admin runs on the same
  // machine, port 8082) — so the link keeps working across network/IP changes without re-pointing.
  SERVICEURL_V2:
    process.env.REACT_APP_SERVICEURL_V2 ||
    `http://${typeof window !== 'undefined' ? window.location.hostname : 'localhost'}:8082`,
} as const;

// Runtime check to ensure env variables exist
Object.entries(AppConstants).forEach(([key, value]) => {
  if (!value) {
    throw new Error(`Missing environment variable: ${key}`);
  }
});

// Optional environment flags
export const IS_DEV = process.env.NODE_ENV === 'development';
export const IS_PROD = process.env.NODE_ENV === 'production';
